const mediaItems = [
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20video%20thumbnail%20with%20breaking%20news%20visual%20style%2C%20red%20and%20dark%20color%20scheme%2C%20dramatic%20lighting%2C%20news%20studio%20background%20with%20screens%2C%20professional%20broadcast%20aesthetic&width=800&height=450&seq=media-1-51cg-2026&orientation=landscape',
    title: '独家解析：某顶流事件完整时间线复盘',
    duration: '15:42',
    views: '128W',
    date: '2天前',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=Talk%20show%20style%20entertainment%20discussion%20set%20with%20warm%20lighting%2C%20two%20hosts%20setup%2C%20modern%20podcast%20studio%20with%20accent%20lighting%2C%20gossip%20and%20entertainment%20theme&width=800&height=450&seq=media-2-51cg-2026&orientation=landscape',
    title: '吃瓜圆桌派：本月最值得关注的五大八卦',
    duration: '22:08',
    views: '96W',
    date: '3天前',
  },
  {
    thumbnail: 'https://readdy.ai/api/search-image?query=News%20montage%20with%20multiple%20screens%20showing%20entertainment%20headlines%2C%20data%20visualization%20style%2C%20dark%20background%20with%20warm%20red%20accents%2C%20modern%20media%20production%20vibe&width=800&height=450&seq=media-3-51cg-2026&orientation=landscape',
    title: '数字盘点：今年娱乐圈热度数据大揭秘',
    duration: '18:30',
    views: '85W',
    date: '5天前',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            视频专区
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">热门爆料视频解读，吃瓜也要有声有色</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/30 transition-colors group"
            >
              {/* Thumbnail */}
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play button overlay */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-background-950/60 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-background-950/70 text-background-50 rounded backdrop-blur-sm whitespace-nowrap">
                  {item.duration}
                </span>
              </div>

              {/* Info */}
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                  <span>{item.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}